// extracted by mini-css-extract-plugin
export default {"balanceBlock":"Balance_balanceBlock__qbi9o","balanceHeader":"Balance_balanceHeader__Apux4","balanceCount":"Balance_balanceCount__xEDSd","button":"Balance_button__HwDGW"};